'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dPresto$0024$0024anon$002414 from "./presto.-Presto$$anon$14.js";
import * as $j_presto$002etypes$0024$002dAccount$002dId$0024 from "./presto.types$-Account-Id$.js";
import * as $j_presto$002etypes$0024$002dEmail$0024 from "./presto.types$-Email$.js";
import * as $j_presto$002etypes$0024$002dMorbid$002dUser$002dDetails$0024 from "./presto.types$-Morbid-User-Details$.js";
var $p;
/** @constructor */
function $c_Lpresto_Presto$$anon$13() {
  this.bb0 = null;
  this.baS = null;
  this.baT = false;
  this.bb1 = null;
  this.bb2 = false;
  this.bb5 = null;
  this.baY = null;
  this.baZ = false;
  this.baU = null;
  this.baV = false;
  this.baW = null;
  this.baX = false;
  this.bb3 = false;
  this.bb4 = false;
  this.bb0 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bb5 = "MorbidUserDetails";
}
export { $c_Lpresto_Presto$$anon$13 as $c_Lpresto_Presto$$anon$13 };
$p = $c_Lpresto_Presto$$anon$13.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Presto$$anon$13;
/** @constructor */
function $h_Lpresto_Presto$$anon$13() {
}
export { $h_Lpresto_Presto$$anon$13 as $h_Lpresto_Presto$$anon$13 };
$h_Lpresto_Presto$$anon$13.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.bb0;
});
$p.L = (function() {
  if ((!this.baT)) {
    this.baS = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.baT = true;
  }
  return this.baS;
});
$p.O = (function() {
  if ((!this.bb2)) {
    this.bb1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bb2 = true;
  }
  return this.bb1;
});
$p.E = (function() {
  return this.bb5;
});
$p.t = (function() {
  if ((!this.baZ)) {
    this.baY = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("email", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("account", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.baZ = true;
  }
  return this.baY;
});
$p.M = (function() {
  if ((!this.baV)) {
    this.baU = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dEmail$0024.$m_Lpresto_types$Email$().cG(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dAccount$002dId$0024.$m_Lpresto_types$AccountId$().bl(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.baV = true;
  }
  return this.baU;
});
$p.Q = (function() {
  if ((!this.baX)) {
    this.baW = new $j_presto$002e$002dPresto$0024$0024anon$002414.$c_Lpresto_Presto$$anon$14();
    this.baX = true;
  }
  return this.baW;
});
$p.w = (function() {
  if ((!this.bb4)) {
    this.bb3 = false;
    this.bb4 = true;
  }
  return this.bb3;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee91) => ((p) => \u03b4scrutinee91.GE(p)))($j_presto$002etypes$0024$002dMorbid$002dUser$002dDetails$0024.$m_Lpresto_types$MorbidUserDetails$())));
});
var $d_Lpresto_Presto$$anon$13 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Presto$$anon$13, "presto.Presto$$anon$13", ({
  N8: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_Presto$$anon$13 as $d_Lpresto_Presto$$anon$13 };
//# sourceMappingURL=presto.-Presto$$anon$13.js.map
